import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeSection from "../HomeSection/HomeSection_00";
import HomeFloatingContent from "../HomeFloatingContent/HomeFloatingContent_00";

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const component = useRef({})
	const pw = useRef({})
	const tag_page = useRef({})
	const component_order = useRef(0)

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(component.current = props.dados_component)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)
            set_dados(tag_page.current = props.tag_page)
            set_dados(component_order.current = props.component_order)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        component.current.info.tag === 'floating' ?
            <HomeFloatingContent pag_welcome={true} dados_config={dados_config.current} dados_component={component.current} component_order={component_order.current} layout={'home-floating-content-' + tag_page.current} />
        :
        component.current.info.tag === 'section' ?
            <HomeSection pag_welcome={true} dados_config={dados_config.current} dados_component={component.current} component_order={component_order.current} layout={'home-floating-content-' + tag_page.current} />
        :
            null

    )
}
